import { Pipe, PipeTransform } from '@angular/core';
import { Folder, Subfolder, Document } from '../../../models/models';

@Pipe({
  name: 'tableData',
  standalone: true
})
export class TableDataPipe implements PipeTransform {
  transform(folder: Folder | null): (Subfolder | Document)[] {
    return folder ? [...folder.folders, ...folder.files] : [];
  }
}
